import React from 'react';
import theme from 'shared/constants/theme.json';

export default () => {
  const textSecondary = theme['text-color-secondary'];
  const textColor = theme['text-color'];
  const primaryColor = theme['primary-color'];
  const borderColor = theme['border-color-base'];

  return (
    <svg width="230" height="280" viewBox="0 0 230 280" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="229" height="279" fill="white" />
      <path d="M46.9976 21H183.405M84.8331 37.5854H144.573" stroke={textSecondary} strokeWidth="3" />
      <path d="M12.6492 135.368V58.7511L114.423 97.2973L12.6492 135.368ZM13.5197 136.11L115.841 97.8345L216.9 136.11H13.5197ZM217.753 135.364L117.262 97.3031L217.753 59.7125V135.364ZM217.753 58.6448L115.843 96.766L13.7148 58.0854H217.753V58.6448Z" stroke={textSecondary} />
      <path d="M21.1751 208.049H56.0236V206.098H21.1751V208.049Z" fill={textColor} />
      <path d="M60.0063 215.854H15.2011V214.878H60.0063V215.854Z" fill={textColor} />
      <path d="M55.0279 227.561H15.2011V226.585H55.0279V227.561Z" fill={textColor} />
      <path d="M15.2011 239.268H60.0063V238.293H15.2011V239.268Z" fill={textColor} />
      <path d="M60.0063 250.976H15.2011V250H60.0063V250.976Z" fill={textColor} />
      <path d="M15.2011 219.756H50.0496V218.78H15.2011V219.756Z" fill={textColor} />
      <path d="M50.0496 231.463H15.2011V230.488H50.0496V231.463Z" fill={textColor} />
      <path d="M15.2011 243.171H50.0496V242.195H15.2011V243.171Z" fill={textColor} />
      <path d="M50.0496 254.878H15.2011V253.902H50.0496V254.878Z" fill={textColor} />
      <path d="M15.2011 223.659H60.0063V222.683H15.2011V223.659Z" fill={textColor} />
      <path d="M55.0279 235.366H15.2011V234.39H55.0279V235.366Z" fill={textColor} />
      <path d="M15.2011 247.073H55.0279V246.098H15.2011V247.073Z" fill={textColor} />
      <path d="M60.0063 258.78H15.2011V257.805H60.0063V258.78Z" fill={textColor} />
      <path d="M21.1751 208.049H56.0236V206.098H21.1751V208.049Z" stroke={textSecondary} />
      <path d="M60.0063 215.854H15.2011V214.878H60.0063V215.854Z" stroke={textSecondary} />
      <path d="M55.0279 227.561H15.2011V226.585H55.0279V227.561Z" stroke={textSecondary} />
      <path d="M15.2011 239.268H60.0063V238.293H15.2011V239.268Z" stroke={textSecondary} />
      <path d="M60.0063 250.976H15.2011V250H60.0063V250.976Z" stroke={textSecondary} />
      <path d="M15.2011 219.756H50.0496V218.78H15.2011V219.756Z" stroke={textSecondary} />
      <path d="M50.0496 231.463H15.2011V230.488H50.0496V231.463Z" stroke={textSecondary} />
      <path d="M15.2011 243.171H50.0496V242.195H15.2011V243.171Z" stroke={textSecondary} />
      <path d="M50.0496 254.878H15.2011V253.902H50.0496V254.878Z" stroke={textSecondary} />
      <path d="M15.2011 223.659H60.0063V222.683H15.2011V223.659Z" stroke={textSecondary} />
      <path d="M55.0279 235.366H15.2011V234.39H55.0279V235.366Z" stroke={textSecondary} />
      <path d="M15.2011 247.073H55.0279V246.098H15.2011V247.073Z" stroke={textSecondary} />
      <path d="M60.0063 258.78H15.2011V257.805H60.0063V258.78Z" stroke={textSecondary} />
      <path d="M98.8375 208.049H133.686V206.098H98.8375V208.049Z" fill={textColor} />
      <path d="M137.669 215.854H92.8635V214.878H137.669V215.854Z" fill={textColor} />
      <path d="M132.69 227.561H92.8635V226.585H132.69V227.561Z" fill={textColor} />
      <path d="M92.8635 239.268H137.669V238.293H92.8635V239.268Z" fill={textColor} />
      <path d="M137.669 250.976H92.8635V250H137.669V250.976Z" fill={textColor} />
      <path d="M92.8635 219.756H127.712V218.78H92.8635V219.756Z" fill={textColor} />
      <path d="M127.712 231.463H92.8635V230.488H127.712V231.463Z" fill={textColor} />
      <path d="M92.8635 243.171H127.712V242.195H92.8635V243.171Z" fill={textColor} />
      <path d="M127.712 254.878H92.8635V253.902H127.712V254.878Z" fill={textColor} />
      <path d="M92.8635 223.659H137.669V222.683H92.8635V223.659Z" fill={textColor} />
      <path d="M132.69 235.366H92.8635V234.39H132.69V235.366Z" fill={textColor} />
      <path d="M92.8635 247.073H132.69V246.098H92.8635V247.073Z" fill={textColor} />
      <path d="M137.669 258.78H92.8635V257.805H137.669V258.78Z" fill={textColor} />
      <path d="M98.8375 208.049H133.686V206.098H98.8375V208.049Z" stroke={textSecondary} />
      <path d="M137.669 215.854H92.8635V214.878H137.669V215.854Z" stroke={textSecondary} />
      <path d="M132.69 227.561H92.8635V226.585H132.69V227.561Z" stroke={textSecondary} />
      <path d="M92.8635 239.268H137.669V238.293H92.8635V239.268Z" stroke={textSecondary} />
      <path d="M137.669 250.976H92.8635V250H137.669V250.976Z" stroke={textSecondary} />
      <path d="M92.8635 219.756H127.712V218.78H92.8635V219.756Z" stroke={textSecondary} />
      <path d="M127.712 231.463H92.8635V230.488H127.712V231.463Z" stroke={textSecondary} />
      <path d="M92.8635 243.171H127.712V242.195H92.8635V243.171Z" stroke={textSecondary} />
      <path d="M127.712 254.878H92.8635V253.902H127.712V254.878Z" stroke={textSecondary} />
      <path d="M92.8635 223.659H137.669V222.683H92.8635V223.659Z" stroke={textSecondary} />
      <path d="M132.69 235.366H92.8635V234.39H132.69V235.366Z" stroke={textSecondary} />
      <path d="M92.8635 247.073H132.69V246.098H92.8635V247.073Z" stroke={textSecondary} />
      <path d="M137.669 258.78H92.8635V257.805H137.669V258.78Z" stroke={textSecondary} />
      <path d="M176.5 208.049H211.348V206.098H176.5V208.049Z" fill={textColor} />
      <path d="M215.331 215.854H170.526V214.878H215.331V215.854Z" fill={textColor} />
      <path d="M210.353 227.561H170.526V226.585H210.353V227.561Z" fill={textColor} />
      <path d="M170.526 239.268H215.331V238.293H170.526V239.268Z" fill={textColor} />
      <path d="M215.331 250.976H170.526V250H215.331V250.976Z" fill={textColor} />
      <path d="M170.526 219.756H205.374V218.78H170.526V219.756Z" fill={textColor} />
      <path d="M205.374 231.463H170.526V230.488H205.374V231.463Z" fill={textColor} />
      <path d="M170.526 243.171H205.374V242.195H170.526V243.171Z" fill={textColor} />
      <path d="M205.374 254.878H170.526V253.902H205.374V254.878Z" fill={textColor} />
      <path d="M170.526 223.659H215.331V222.683H170.526V223.659Z" fill={textColor} />
      <path d="M210.353 235.366H170.526V234.39H210.353V235.366Z" fill={textColor} />
      <path d="M170.526 247.073H210.353V246.098H170.526V247.073Z" fill={textColor} />
      <path d="M215.331 258.78H170.526V257.805H215.331V258.78Z" fill={textColor} />
      <path d="M176.5 208.049H211.348V206.098H176.5V208.049Z" stroke={textSecondary} />
      <path d="M215.331 215.854H170.526V214.878H215.331V215.854Z" stroke={textSecondary} />
      <path d="M210.353 227.561H170.526V226.585H210.353V227.561Z" stroke={textSecondary} />
      <path d="M170.526 239.268H215.331V238.293H170.526V239.268Z" stroke={textSecondary} />
      <path d="M215.331 250.976H170.526V250H215.331V250.976Z" stroke={textSecondary} />
      <path d="M170.526 219.756H205.374V218.78H170.526V219.756Z" stroke={textSecondary} />
      <path d="M205.374 231.463H170.526V230.488H205.374V231.463Z" stroke={textSecondary} />
      <path d="M170.526 243.171H205.374V242.195H170.526V243.171Z" stroke={textSecondary} />
      <path d="M205.374 254.878H170.526V253.902H205.374V254.878Z" stroke={textSecondary} />
      <path d="M170.526 223.659H215.331V222.683H170.526V223.659Z" stroke={textSecondary} />
      <path d="M210.353 235.366H170.526V234.39H210.353V235.366Z" stroke={textSecondary} />
      <path d="M170.526 247.073H210.353V246.098H170.526V247.073Z" stroke={textSecondary} />
      <path d="M215.331 258.78H170.526V257.805H215.331V258.78Z" stroke={textSecondary} />
      <rect x="21.5" y="148.5" width="188" height="45" fill={primaryColor} fillOpacity="0.25" />
      <line x1="34" y1="157.5" x2="124" y2="157.5" stroke={textColor} strokeWidth="3" />
      <line x1="42" y1="168.5" x2="87" y2="168.5" stroke={textSecondary} />
      <line x1="42" y1="174.5" x2="74" y2="174.5" stroke={textSecondary} />
      <line x1="42" y1="180.5" x2="92" y2="180.5" stroke={textSecondary} />
      <circle cx="36" cy="168" r="2" fill="white" />
      <circle cx="36" cy="168" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
      <circle cx="36" cy="174" r="2" fill="white" />
      <circle cx="36" cy="174" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
      <circle cx="36" cy="180" r="2" fill="white" />
      <circle cx="36" cy="180" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
      <rect x="21.5" y="148.5" width="188" height="45" stroke={primaryColor} />
      <rect x="0.5" y="0.5" width="229" height="279" stroke={borderColor} />
    </svg>

  );
};
